import { createAsyncThunk } from '@reduxjs/toolkit';
import { getSaturationUnloadingPointsFiltersUseCase } from 'modules/inbound/entries/application/UnloadingPoints/GetSaturationUnloadingPointsFiltersUseCase';

export const getSaturationUnloadingPointsFilters = createAsyncThunk(
  'saturationUnloadingentriesST12PointsFilters/getSaturationUnloadingPointsFilters',
  () => {
    return getSaturationUnloadingPointsFiltersUseCase.execute();
  }
);
